import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import Utils from "models/helper/Utils";
import RSVP from "rsvp";
import ti18n from "i18n!nls/UserChangePasswordi18n";
import PublicResetPasswordPageView from "views/user/PublicResetPasswordPageView";

const PublicResetPasswordPageController =  Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        this.model = null;
        this._pageId = options.pageId;
        this._passwordResetToken = options.passwordResetToken || null;
    },

    getView : function(){
        return this.view;
    },

    saveChanges : function(dataToChange){
        if(!this._passwordResetToken){
            window.alertErrorMessage(window.getI18n(ti18n, "PASSWORD_RESET_TOKEN_MISSING"));
            this.view.setSaveButtonEnabled(true);
            return RSVP.Promise.resolve(false);
        }

        $.mobile.loading("show");
        return TrebbleClientAPIHelper.getInstance().completePasswordReset(this._passwordResetToken, dataToChange.newPassword).then((function(){
            $.mobile.loading("hide");
            this._passwordResetToken = null;
            this._clearPasswordResetTokenFromUrl();
            window.alertSuccessMessage(window.getI18n(ti18n, "YOUR_PASSWORD_WAS_CHANGED_PLEASE_LOGIN"));
            this.view.navigateToLoginPage();
        }).bind(this)).catch((function(error){
            $.mobile.loading("hide");
            this.view.setSaveButtonEnabled(true);
            window.alertErrorMessage(error || window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_RESETTING_PASSWORD"));
        }).bind(this));
    },

    _clearPasswordResetTokenFromUrl : function(){
        try {
            if(!window.history || !window.history.replaceState){
                return;
            }

            var location = window.location;
            var updatedSearch = location.search;
            var searchParams = new URLSearchParams(Utils.getInstance().cleanQueryString(location.search));
            if(searchParams.has("token")){
                searchParams.delete("token");
                var rebuiltSearch = searchParams.toString();
                updatedSearch = rebuiltSearch ? "?" + rebuiltSearch : "";
            }

            var updatedHash = location.hash;
            if(location.hash && location.hash.indexOf("?") !== -1){
                var hashQueryIndex = location.hash.indexOf("?");
                var hashBase = location.hash.substring(0, hashQueryIndex);
                var hashQueryString = location.hash.substring(hashQueryIndex);
                var hashSearchParams = new URLSearchParams(Utils.getInstance().cleanQueryString(hashQueryString));
                if(hashSearchParams.has("token")){
                    hashSearchParams.delete("token");
                    var rebuiltHashQuery = hashSearchParams.toString();
                    updatedHash = rebuiltHashQuery ? hashBase + "?" + rebuiltHashQuery : hashBase;
                }
            }

            if(updatedSearch !== location.search || updatedHash !== location.hash){
                window.history.replaceState(window.history.state, "", location.pathname + updatedSearch + updatedHash);
            }
        } catch(error){
            // Non-fatal: leave URL unchanged if rewrite fails
        }
    },

    buildModelAndRenderView : function() {
        return new RSVP.Promise((function(resolve, reject) {
            try {
                const pageViewParams= {};
                pageViewParams.pageId = this._pageId;
                this.view = new PublicResetPasswordPageView(pageViewParams);
                this.view.render();
                this.listenTo(this.view, "saveChanges", this.saveChanges);
                resolve(this);
            } catch (error) {
                reject(error);
            }
        }).bind(this));
    }

});
export default PublicResetPasswordPageController;
